module.exports = __webpack_public_path__ + "static/media/logo-anajatuba.86d5017b.png";